export enum DocumentType {
    FieldSheet = 0,
    ChainOfCustody = 1,
    CalibrationRecord = 2,
    Letters = 3,
    LabResult = 4,
    Report = 5
}